import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { UpgradeModule } from '@angular/upgrade/static';

import { IbGiftCardsConfirmationComponent } from './ib-gift-cards-confirmation.component';
import { NgReactModule } from '@src/app/react/ng-react.module';

@NgModule({
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    declarations: [
        IbGiftCardsConfirmationComponent
    ],
    exports: [
        IbGiftCardsConfirmationComponent
    ],
    imports: [
        CommonModule,
        UpgradeModule,
        TranslateModule,
        NgReactModule
    ]
})

export class IbGiftCardsConfirmationModule { }
export { IbGiftCardsConfirmationComponent } from './ib-gift-cards-confirmation.component';
